import axios from 'axios';

export default async function deleteGuest({
  accessToken,
  id,
  setTokenLikeExpired,
  setIsFetching,
}) {
  const requestOptions = {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  };

  try {
    setIsFetching(true);

    const { data } = await axios.delete(
      `${process.env.REACT_APP_GUESTS_API_URL}/${id}`,
      requestOptions,
    );

    return data;
  } catch (err) {
    if (err.response?.status === 401 && setTokenLikeExpired) setTokenLikeExpired();

    return null;
  } finally {
    setIsFetching(false);
  }
}
